import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=8cbe934c&scoped=true&"
import script from "./growth.vue?vue&type=script&lang=js&"
export * from "./growth.vue?vue&type=script&lang=js&"
import style0 from "./growth.vue?vue&type=style&index=0&id=8cbe934c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe934c",
  null
  
)

export default component.exports